<template>
  <div
    class="pch-textchat-home"
    style="height: 100%"
  >
    <v-form
      @submit.stop.prevent="submit"
      v-model="valid"
      style="height: 100%"
    >
      <div
        style="height: calc(100% - 62px); overflow-y: auto;"
        class="pa-3"
      >
        <div class="messageBox business">
          <div class="message">
            <span class="bgrd" :style="{ backgroundColor: color }"></span>
            <span>{{ $renderSmartText($store.getters.widgetSettings.message_text || 'Enter your information and our team will text you shortly.') }}</span>
          </div>
        </div>
        <!-- Location Dropdown Shows if dropdown is enabled and there are multiple locations -->
        <v-select
          v-if="locationDropdownEnabled"
          placeholder="Location to send message to"
          :items="$store.state.locations"
          item-text="name"
          item-value="_id"
          v-model="selectedLocation"
          :disabled="loading"
          :color="color"
          :item-color="color"
          hide-details
          dense
          class="mb-5"
        />
        <div v-show="locationPicked">
          <v-text-field
            label="First Name"
            placeholder="First Name"
            single-line
            dense
            :color="color"
            :disabled="loading"
            :rules="nameRules"
            v-model="contact.first_name"
          />
          <v-text-field
            label="Phone Number"
            placeholder="Phone Number"
            single-line
            dense
            type="tel"
            :color="color"
            :disabled="loading"
            :rules="phoneRules"
            v-model="contact.phone"
          />
          <v-textarea
            class="input-message"
            label="Message"
            placeholder="Message"
            single-line
            dense
            no-resize
            auto-grow
            :color="color"
            :rows="1"
            :disabled="loading"
            :rules="messageRules"
            v-model="message"
          />
          <v-select
            v-if="tagItems && tagItems.length"
            :label="tagDropdownLabel"
            :placeholder="tagDropdownLabel"
            single-line
            :items="tagItems"
            v-model="tags"
            multiple
            hide-details
            :color="color"
            :item-color="color"
            :menu-props="{ offsetY: true, closeOnContentClick: true }"
            :disabled="loading"
            dense
          />
          <v-checkbox
            v-if="!$store.getters.widgetSettings.hide_sms_on"
            class="sms-on mt-3"
            label="Add me to the text list for offers and updates. (optional)"
            :color="color"
            :disabled="loading"
            hide-details
            dense
            v-model="contact.sms_on"
          ></v-checkbox>
        </div>
        <v-alert
          v-model="error"
          dismissible
          color="error"
          dark
          dense
          class="mt-2 mb-0"
        >
          {{ error }}
        </v-alert>
        <p
          v-if="!error"
          class="fine-print caption fade mt-3"
          style="opacity: 0.7; font-weight: 400; padding-top: 1em; margin-bottom: 0.25em; line-height: 1.25rem;"
        >By submitting you agree to receive a reply via text message at the phone number provided. Message / data rates apply. <a @click="$store.commit('setShowTerms', true)" style="cursor: pointer;">Click here for Privacy Policy & Terms.</a></p>
      </div>
      <div
        class="d-flex pa-3"
        style="height: 62px"
      >
        <div
          class="flex-grow-1"
        >
          <branding-view />
        </div>
        <div
          style="width: 130px"
        >
          <v-btn
            type="submit"
            block
            :color="color"
            :loading="loading"
            :disabled="loading || !valid || !locationPicked"
          >Send</v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss">
.pch-textchat-home {
  .input-message {
    .v-messages {
      opacity: 0;
    }
  }
  .sms-on .v-input__control .v-label {
    font-size: .75em;
    line-height: 1.25;
  }
  .v-btn {
    color: #fff;
  }
}
</style>

<script>
import BrandingView from '../Branding'

export default {
  components: {
    BrandingView
  },
  data () {
    return {
      error: null,
      valid: null,
      tags: null,
      message: null,
      contact: {
        first_name: this.$store.state.contact?.first_name || '',
        phone: this.$store.state.contact?.phone,
        sms_on: null
      },
      loading: false
    }
  },
  computed: {
    color () {
      return this.$store.getters?.color
    },
    locationDropdownEnabled () {
      return this.$store.getters.widgetSettings.show_location_dropdown && !!(this.$store.state.locations || []).length
    },
    tagDropdownLabel () {
      return this.$store.getters.widgetSettings?.tags_dropdown_label || 'Question Type'
    },
    tagItems () {
      return (this.$store.getters.widgetSettings?.tags || []).map(tag => ({
        value: tag.value,
        text: tag.text || tag.value
      }))
    },
    nameRules () {
      return [
        v => !!v || 'Name is required'
      ]
    },
    phoneRules () {
      return [
        (v) => !!v || 'Phone is required',
        (v) => {
          v = (v + '').replace(/\D/g, '')
          return v.length === 10 ||
          (
            v.startsWith('1') &&
              v.length === 11
          ) ||
          'Must be a valid US mobile phone number'
        }
      ]
    },
    messageRules () {
      return [
        (v) => !!v || 'Message is required'
      ]
    },
    contactName () {
      return this.$store.state.contact?.first_name || ''
    },
    contactPhone () {
      return this.$store.state.contact?.phone || ''
    },
    selectedLocation: {
      get () {
        return this.$store.state.selectedAccountId
      },
      set (value) {
        this.$store.commit('setSelectedAccountId', value)
      }
    },
    locationPicked () {
      // If dropdown is enabled, prevent auto-selecting the first location
      return !this.locationDropdownEnabled || this.selectedLocation !== undefined
    }
  },
  methods: {
    async submit () {
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        await this.$store.dispatch('submit', {
          // contact_id: this.$store.state?.contact?._id,
          contact: {
            ...this.contact,
            sms_on: this.contact.sms_on ? true : undefined
          },
          message: this.message,
          tags: this.tags
        })
      } catch (e) {
        this.error = e.message
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
